'use client'

import React, { FC, useEffect, useState } from 'react'

import RichText from '@/components/RichText'
import { CMSLink } from '@/components/Link'

import type { CoachCTABlock as BlockProps } from '@/payload-types'

export const CoachCTABlock: FC<BlockProps> = ({ links, richText, media, height }) => {
  const [bgX, setBgX] = useState(0)

  useEffect(() => {
    let frameRequest: number

    function onFrame() {
      setBgX(bgX + 0.01)
      frameRequest = window.requestAnimationFrame(onFrame)
    }

    frameRequest = window.requestAnimationFrame(onFrame)
    return () => {
      window.cancelAnimationFrame(frameRequest)
    }
  })

  return (
    <div
      className={'bg-cover relative overflow-hidden -my-[1px]'}
      style={{ backgroundImage: typeof media === 'object' ? `url(${media.url})` : '' }}
    >
      <div
        className={'py-[100px] sm:py-0 sm:h-dvh flex w-full'}
        style={{ maxHeight: height ?? undefined }}
      >
        <div className={'self-center flex w-full flex-col -rotate-1 scale-105'}>
          <div
            className={'h-[40px] w-full -mb-[1px]'}
            style={{
              backgroundImage: `url(/media/film-strip-top-black.png)`,
              backgroundSize: 'contain',
              backgroundRepeat: 'repeat-x',
              backgroundPosition: `${bgX}rem 0`,
            }}
          ></div>
          <div className={'bg-black text-white'}>
            <div className="container mb-8 my-4 py-4 z-10 relative flex items-center justify-center">
              <div className="max-w-[36.5rem] text-center">
                {richText && <RichText className="mb-6" content={richText} enableGutter={false} />}
                <div className="flex justify-center gap-4">
                  {Array.isArray(links) &&
                    links.length > 0 &&
                    links.map(({ link }, i) => {
                      return (
                        <div key={i}>
                          <CMSLink {...link} />
                        </div>
                      )
                    })}
                </div>
              </div>
            </div>
          </div>
          <div
            className={'h-[40px] w-full -mt-[1px]'}
            style={{
              backgroundImage: `url(/media/film-strip-bottom-black.png)`,
              backgroundSize: 'contain',
              backgroundRepeat: 'repeat-x',
              backgroundPosition: `${bgX}rem 0`,
            }}
          ></div>
        </div>
      </div>
    </div>
  )
}
